
import { useQuery } from '@tanstack/react-query';
import { supabase } from '@/integrations/supabase/client';

export const useGames = () => {
  return useQuery({
    queryKey: ['games'],
    queryFn: async () => {
      //console.log('Fetching all games from database...');
      
      const { data, error } = await supabase
        .from('games')
        .select('*')
        .order('name');

      if (error) {
        console.error('Error fetching games:', error);
        throw error;
      }
      
      //console.log('Games fetched successfully:', data?.length, 'games found');
      //console.log('Games list:', data?.map(g => g.name));
      
      return data;
    },
    staleTime: 5 * 60 * 1000, // 5 minutes
    refetchOnWindowFocus: false,
  });
};
